/* AsPadel — sélecteur de pala. Cinq questions, un profil cible sur quatre axes, trois palas.
   Vanilla JS, navigation clavier native (boutons radio + boutons), profil stocké en localStorage. */
(function () {
  'use strict';
  if (window.__apSel) return; window.__apSel = true;

  var CLE_PROFIL = 'aspadel_profil';
  var CLE_BROUILLON = 'aspadel_brouillon';

  var QUESTIONS = [
    { id: 'exp', titre: 'Tu joues depuis quand ?', options: [
      { v: 0, l: 'Jamais, ou presque' }, { v: 1, l: "Moins d'un an" }, { v: 2, l: '1 à 3 ans' }, { v: 3, l: 'Plus de 3 ans, ou en compétition' } ] },
    { id: 'style', titre: 'Sur le terrain, tu es plutôt ?', options: [
      { v: 0, l: 'Je défends et je remets' }, { v: 1, l: 'Je fais les deux' }, { v: 2, l: 'Je monte et je smashe' } ] },
    { id: 'freq', titre: 'Tu joues combien de fois par semaine ?', options: [
      { v: 1, l: 'Une fois' }, { v: 2, l: 'Deux fois' }, { v: 3, l: 'Trois fois ou plus' } ] },
    { id: 'douleur', titre: "Tu as déjà eu des douleurs au coude ou à l'épaule en jouant ?", options: [
      { v: 1, l: 'Oui' }, { v: 0, l: 'Non' } ] },
    { id: 'budget', titre: 'Ton budget ?', options: [
      { v: 100, l: 'Moins de 100 €' }, { v: 180, l: '100 à 180 €' }, { v: 280, l: '180 à 280 €' }, { v: 9999, l: 'Plus de 280 €' } ] }
  ];

  function lire(cle) { try { return JSON.parse(localStorage.getItem(cle)); } catch (e) { return null; } }
  function ecrire(cle, val) { try { localStorage.setItem(cle, JSON.stringify(val)); } catch (e) { /* stockage indisponible */ } }
  function effacer(cle) { try { localStorage.removeItem(cle); } catch (e) { /* rien */ } }
  function borne(x) { return Math.max(1, Math.min(10, Math.round(x * 10) / 10)); }

  /* Profil cible sur les quatre axes du radar */
  function profilCible(r) {
    var p = 3 + 2 * r.style + 0.6 * r.exp;
    var c = 4 + (2 - r.style) * 2 + (r.exp >= 2 ? 1 : 0);
    var m = 4 + (r.freq >= 3 ? 2 : r.freq === 2 ? 1 : 0) + (r.douleur ? 3 : 0);
    var z = 4 + (r.exp === 0 ? 4 : r.exp === 1 ? 3 : r.exp === 2 ? 1 : 0) + (r.douleur ? 2 : 0);
    return { p: borne(p), c: borne(c), m: borne(m), z: borne(z) };
  }

  var NIVEAUX = { 0: ['découverte'], 1: ['découverte', 'régulier'], 2: ['régulier', 'compétition', 'découverte'], 3: ['régulier', 'compétition'] };

  function distance(a, b) {
    return Math.sqrt(Math.pow(a.p - b.p, 2) + Math.pow(a.c - b.c, 2) + Math.pow(a.m - b.m, 2) + Math.pow(a.z - b.z, 2));
  }

  /* Classement : règles dures d'abord, puis distance euclidienne */
  function classer(palas, r) {
    var cible = profilCible(r);
    var dures = palas.filter(function (x) {
      if (!x.scores) return false;
      if (x.prix > r.budget) return false;
      if (r.douleur && (x.noyau === 'EVA hard' || x.forme === 'diamant')) return false;
      if (r.exp === 0 && x.niveau.indexOf('compétition') !== -1 && x.niveau.length === 1) return false;
      return true;
    });
    var niveaux = NIVEAUX[r.exp] || NIVEAUX[1];
    var filtrees = dures.filter(function (x) {
      return x.niveau.length === 0 || x.niveau.some(function (n) { return niveaux.indexOf(n) !== -1; });
    });
    if (filtrees.length < 3) filtrees = dures;
    filtrees.forEach(function (x) { x.dist = distance(x.scores, cible); });
    filtrees.sort(function (a, b) { return a.dist - b.dist || a.prix - b.prix; });
    return { cible: cible, resultats: filtrees.slice(0, 3), total: dures.length };
  }

  /* Phrase « pourquoi celle-là pour toi », construite à partir des réponses */
  function pourquoi(x, r, cible, rang, premiere) {
    var s = x.scores;
    var clauses = [];
    if (r.douleur) clauses.push('Noyau ' + x.noyau + (x.equilibre ? ' et équilibre à ' + x.equilibre + ' mm' : '') + ' : moins de vibrations dans le bras, tu finis le match sans serrer les dents.');
    if (r.exp <= 1) clauses.push('Zone douce à ' + s.z + '/10 : tes balles décentrées restent dans le terrain, et tu progresses sans te dégoûter.');
    if (r.style === 2 && r.exp >= 2) clauses.push('Puissance ' + s.p + '/10 avec une forme ' + x.forme + ' : du punch au smash sans sacrifier le centrage.');
    if (r.style === 0) clauses.push('Contrôle ' + s.c + '/10 : la balle part où tu la vises, même en fin de deuxième set.');
    if (r.style === 1 && r.exp >= 2) clauses.push('Puissance ' + s.p + ' et contrôle ' + s.c + ' : le compromis pour un jeu complet, du fond comme au filet.');
    if (r.freq >= 3 && !r.douleur) clauses.push('Maniabilité ' + s.m + '/10 : à trois séances par semaine, tu la sens moins en fin de semaine.');
    if (clauses.length === 0) clauses.push('Son profil est le plus proche du tien sur les quatre axes.');
    var phrase = clauses.slice(0, 2).join(' ');
    if (premiere && rang > 0) {
      var diff = [];
      var p0 = premiere.scores;
      if (s.c - p0.c >= 1) diff.push('plus de contrôle');
      if (s.p - p0.p >= 1) diff.push('plus de puissance');
      if (s.m - p0.m >= 1) diff.push('plus maniable');
      if (s.z - p0.z >= 1) diff.push('plus tolérante');
      if (x.prix < premiere.prix - 15) diff.push((premiere.prix - x.prix) + ' € de moins');
      if (diff.length) phrase = 'Variante ' + diff.slice(0, 2).join(', ') + '. ' + phrase;
    }
    return phrase;
  }

  function etiquette(x, premiere) {
    if (!premiere) return 'Notre choix pour toi';
    var s = x.scores, p0 = premiere.scores;
    var ecarts = [
      ['Plus de contrôle', s.c - p0.c], ['Plus de puissance', s.p - p0.p], ['Plus maniable', s.m - p0.m], ['Plus tolérante', s.z - p0.z]
    ].sort(function (a, b) { return b[1] - a[1]; });
    if (ecarts[0][1] >= 1) return ecarts[0][0];
    if (x.prix < premiere.prix) return 'Moins chère';
    return 'Autre option';
  }

  function euros(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €'; }
  function echapper(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ----- Composant plein écran ----- */
  function Selecteur(racine) {
    this.racine = racine;
    this.url = racine.getAttribute('data-url-collection') || '/collections/all';
    try { this.palas = JSON.parse(racine.querySelector('[data-palas]').textContent).filter(Boolean); } catch (e) { this.palas = []; }
    var brouillon = lire(CLE_BROUILLON) || {};
    this.reponses = brouillon.reponses || {};
    this.etape = brouillon.etape || 0;
    var profil = lire(CLE_PROFIL);
    if (racine.getAttribute('data-reprendre') === 'true' && profil && profil.reponses && !brouillon.reponses) {
      this.reponses = profil.reponses; this.etape = QUESTIONS.length;
    }
    this.racine.addEventListener('click', this.onClick.bind(this));
    this.racine.addEventListener('change', this.onChange.bind(this));
    this.racine.addEventListener('submit', function (e) { e.preventDefault(); });
    this.rendre(false);
  }

  Selecteur.prototype.onChange = function (e) {
    if (e.target.name && e.target.name.indexOf('q-') === 0) {
      var q = QUESTIONS[this.etape];
      this.reponses[q.id] = Number(e.target.value);
      var suivant = this.racine.querySelector('[data-suivant]');
      if (suivant) suivant.disabled = false;
    }
  };

  Selecteur.prototype.onClick = function (e) {
    var b = e.target.closest('[data-action]');
    if (!b) return;
    var action = b.getAttribute('data-action');
    if (action === 'suivant') {
      var q = QUESTIONS[this.etape];
      if (this.reponses[q.id] === undefined) return;
      this.etape += 1;
      ecrire(CLE_BROUILLON, { reponses: this.reponses, etape: this.etape });
      this.rendre(true);
    } else if (action === 'retour') {
      if (this.etape > 0) this.etape -= 1;
      ecrire(CLE_BROUILLON, { reponses: this.reponses, etape: this.etape });
      this.rendre(true);
    } else if (action === 'recommencer') {
      this.reponses = {}; this.etape = 0; effacer(CLE_BROUILLON); effacer(CLE_PROFIL);
      this.rendre(true);
    } else if (action === 'modifier') {
      this.etape = Number(b.getAttribute('data-etape')) || 0;
      ecrire(CLE_BROUILLON, { reponses: this.reponses, etape: this.etape });
      this.rendre(true);
    }
  };

  Selecteur.prototype.rendre = function (focus) {
    var html;
    if (this.etape >= QUESTIONS.length) html = this.rendreResultat();
    else html = this.rendreQuestion();
    this.racine.querySelector('[data-ecran]').innerHTML = html;
    if (focus) {
      var cible = this.racine.querySelector('[data-focus]');
      if (cible) cible.focus();
    }
  };

  Selecteur.prototype.rendreQuestion = function () {
    var i = this.etape, q = QUESTIONS[i], self = this;
    var pct = Math.round((i / QUESTIONS.length) * 100);
    var repondu = this.reponses[q.id] !== undefined;
    return '' +
      '<div class="ap-sel__progression" role="progressbar" aria-valuemin="0" aria-valuemax="' + QUESTIONS.length + '" aria-valuenow="' + i + '" aria-label="Question ' + (i + 1) + ' sur ' + QUESTIONS.length + '"><span style="width:' + pct + '%"></span></div>' +
      '<p class="ap-sel__etape ap-petit ap-douce ap-num">Question ' + (i + 1) + ' sur ' + QUESTIONS.length + '</p>' +
      '<form class="ap-sel__form">' +
      '<fieldset class="ap-sel__fieldset"><legend class="ap-sel__question ap-h2" tabindex="-1" data-focus>' + echapper(q.titre) + '</legend>' +
      '<div class="ap-sel__options">' +
      q.options.map(function (o, k) {
        var id = 'q-' + q.id + '-' + k;
        var coche = self.reponses[q.id] === o.v ? ' checked' : '';
        return '<label class="ap-sel__option" for="' + id + '"><input type="radio" id="' + id + '" name="q-' + q.id + '" value="' + o.v + '"' + coche + '><span>' + echapper(o.l) + '</span></label>';
      }).join('') +
      '</div></fieldset>' +
      '<div class="ap-sel__actions">' +
      (i > 0 ? '<button type="button" class="ap-btn ap-btn--secondaire" data-action="retour">Question précédente</button>' : '') +
      '<button type="button" class="ap-btn" data-action="suivant" data-suivant' + (repondu ? '' : ' disabled') + '>' + (i === QUESTIONS.length - 1 ? 'Voir mes trois palas' : 'Continuer') + '</button>' +
      '</div></form>';
  };

  Selecteur.prototype.rendreResultat = function () {
    var r = {
      exp: this.reponses.exp, style: this.reponses.style, freq: this.reponses.freq, douleur: this.reponses.douleur, budget: this.reponses.budget
    };
    var res = classer(this.palas, r);
    ecrire(CLE_PROFIL, { reponses: r, cible: res.cible, date: new Date().toISOString() });
    effacer(CLE_BROUILLON);
    var self = this;
    var resume = QUESTIONS.map(function (q, k) {
      var o = q.options.filter(function (x) { return x.v === self.reponses[q.id]; })[0];
      return '<li><button type="button" class="ap-pastille" data-action="modifier" data-etape="' + k + '" aria-label="Modifier : ' + echapper(q.titre) + '">' + echapper(o ? o.l : '') + '</button></li>';
    }).join('');
    var corps;
    if (res.resultats.length === 0) {
      var conseil = r.budget <= 100
        ? 'Sous 100 €, on n\'a pas de pala qui respecte tes contraintes. Monte à 180 € : c\'est là que commencent les palas avec une vraie zone douce.'
        : 'Aucune pala ne passe tes contraintes. Modifie une réponse, le budget ou la question sur les douleurs sont les plus restrictives.';
      corps = '<div class="ap-vide"><p>' + conseil + '</p><p><button type="button" class="ap-btn ap-btn--secondaire" data-action="modifier" data-etape="4">Changer le budget</button></p></div>';
    } else {
      var premiere = res.resultats[0];
      corps = '<ol class="ap-sel__resultats">' + res.resultats.map(function (x, k) {
        var prem = k === 0 ? null : premiere;
        var media = x.image
          ? '<img src="' + echapper(x.image) + '" alt="" loading="' + (k === 0 ? 'eager' : 'lazy') + '" width="600" height="600">'
          : '<span class="ap-sel__schema" aria-hidden="true">' + (x.schema || '') + '</span>';
        return '<li class="ap-sel__resultat' + (k === 0 ? ' ap-sel__resultat--premier' : '') + '" style="--ordre:' + k + '">' +
          '<p class="ap-sel__etiquette ap-petit">' + echapper(etiquette(x, prem)) + '</p>' +
          '<a class="ap-carte__media" href="' + echapper(x.url) + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
          '<p class="ap-carte__marque">' + echapper(x.marque || '') + '</p>' +
          '<h3 class="ap-h3"><a class="ap-sel__lien" href="' + echapper(x.url) + '">' + echapper(x.titre) + '</a></h3>' +
          '<p class="ap-carte__prix ap-num">' + euros(x.prix) + '</p>' +
          '<ul class="ap-chips" aria-label="Caractéristiques">' + [x.forme, x.equilibre ? x.equilibre + ' mm' : null, x.noyau].filter(Boolean).map(function (c) { return '<li class="ap-chip">' + echapper(c) + '</li>'; }).join('') + '</ul>' +
          '<p class="ap-sel__pourquoi">' + echapper(pourquoi(x, r, res.cible, k, prem)) + '</p>' +
          '</li>';
      }).join('') + '</ol>';
      if (res.resultats.length < 3) corps += '<p class="ap-douce ap-sel__note">Seulement ' + res.resultats.length + ' pala' + (res.resultats.length > 1 ? 's' : '') + ' respecte' + (res.resultats.length > 1 ? 'nt' : '') + ' tes contraintes. C\'est volontaire : on ne complète pas avec des palas qui ne te conviennent pas.</p>';
    }
    return '' +
      '<div class="ap-sel__progression" role="progressbar" aria-valuemin="0" aria-valuemax="' + QUESTIONS.length + '" aria-valuenow="' + QUESTIONS.length + '" aria-label="Terminé"><span style="width:100%"></span></div>' +
      '<h2 class="ap-h2" tabindex="-1" data-focus>' + (res.resultats.length ? 'Tes trois palas' : 'Rien ne colle, pour l\'instant') + '</h2>' +
      '<p class="ap-section__sous">Profil calculé : puissance ' + res.cible.p + ', contrôle ' + res.cible.c + ', maniabilité ' + res.cible.m + ', zone douce ' + res.cible.z + ' sur 10.</p>' +
      '<ul class="ap-sel__resume" aria-label="Tes réponses, clique pour modifier">' + resume + '</ul>' +
      corps +
      '<div class="ap-sel__actions ap-sel__actions--fin">' +
      '<a class="ap-btn ap-btn--secondaire" href="' + echapper(this.url) + '">Voir toutes les palas triées pour toi</a>' +
      '<button type="button" class="ap-lien ap-sel__reset" data-action="recommencer">Recommencer</button>' +
      '</div>';
  };

  /* ----- Amorce dans le hero : la première question est cliquable ----- */
  function amorce(racine) {
    var url = racine.getAttribute('data-url-selecteur') || '/pages/selecteur';
    racine.addEventListener('click', function (e) {
      var b = e.target.closest('[data-amorce]');
      if (!b) return;
      ecrire(CLE_BROUILLON, { reponses: { exp: Number(b.getAttribute('data-amorce')) }, etape: 1 });
      window.location.href = url;
    });
  }

  /* ----- Bandeau de rappel + tri par pertinence sur les collections ----- */
  function collection(racine) {
    var profil = lire(CLE_PROFIL);
    var bandeau = racine.querySelector('[data-profil-bandeau]');
    if (!profil || !profil.cible || !bandeau) return;
    var r = profil.reponses || {};
    var resume = [];
    QUESTIONS.forEach(function (q) {
      var o = q.options.filter(function (x) { return x.v === r[q.id]; })[0];
      if (o) resume.push(o.l);
    });
    bandeau.querySelector('[data-profil-texte]').textContent = resume.join(', ');
    bandeau.hidden = false;
    window.aspadelTrier = function () {
      var grille = document.querySelector('[data-grille-palas]');
      if (!grille) return;
      var items = Array.prototype.slice.call(grille.children);
      items.forEach(function (li) {
        var s = li.getAttribute('data-scores');
        var prix = Number(li.getAttribute('data-prix')) || 0;
        var d = 99;
        if (s) {
          try { var sc = JSON.parse(s); d = distance(sc, profil.cible); } catch (e) { d = 99; }
        }
        if (r.budget && prix > r.budget) d += 5;
        if (r.douleur && (li.getAttribute('data-noyau') === 'EVA hard' || li.getAttribute('data-forme') === 'diamant')) d += 10;
        li.dataset.dist = d;
      });
      items.sort(function (a, b) { return Number(a.dataset.dist) - Number(b.dataset.dist); });
      items.forEach(function (li) { grille.appendChild(li); });
      grille.setAttribute('data-trie', 'pertinence');
    };
    window.aspadelTrier();
  }

  function init() {
    document.querySelectorAll('[data-selecteur]').forEach(function (el) { new Selecteur(el); });
    document.querySelectorAll('[data-amorce-racine]').forEach(amorce);
    document.querySelectorAll('[data-collection-profil]').forEach(collection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
